/* eslint eqeqeq: "off" */
import * as React from 'react';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setTimeShow, resetCoverItem, handleNextStep, setDisclaimer, setDate, setTime, getVehicleTypes, getVehicleForcedEntryTypes, getAllRiskStolenLocations, setStep, setFnolReducerPayload, checkCellphoneDuplicateClaim, submitBlingFNOL, submitGeneralClaim, checkDateTime, getDateString } from '../../../actions/claimSubmitActions';
import { navigateTo } from '../../../actions/navigationActions';
import { showBlacklistInfo, showPoliceReportInfo, showDuplicateClaim } from '../../../actions/modalActions';
import './Cellphone.css';
import TimeKeeper from 'react-timekeeper';
import ModernDatepicker from 'react-modern-datepicker';
import '../../FNOL/FNOL.css';
import { CELLPHONE_CLAIM_ACCIDENTAL_ID, CELLPHONE_CLAIM_INTENTIONAL_ID, CELLPHONE_CLAIM_LOSS_ID, CELLPHONE_CLAIM_THEFT_ID, CELLPHONE_CLAIM_OTHER_ID } from '../../../constants/products';
import ReactTooltip from 'react-tooltip';

class CellphoneClaimsDetails extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            coverToggle: false,
            stepSubmitted: false,
            nextDisabled: false,
            causeOfCollision: this.props.claimSubmit.incidentEventType,
            hasCause: this.props.claimSubmit.incidentEventType !== "",
            hasDate: this.props.claimSubmit.incidentDate !== "",
            hasTime: this.props.claimSubmit.incidentTime !== "",
            hasTimeChanged: false,
            startDate: this.props.claimSubmit.incidentDate,
            time24: "12:00",
            time12: "12:00 pm",
            maxDate: new Date(),
            mouseOut: false,
            isClosed: false,
            name: "",
            surname: "",
            contact: "",
            incidentDescriptionWhat: this.props.claimSubmit.whatDescription,
            selfDamage: "",
            householdPerson: undefined,
            reported: undefined,
            policeStation: "",
            policeNumber: "",
            isBlacklisted: undefined,
            blacklistNumber: "",
            forcedEntry: undefined,
            reRender: false,
            vehicleSelection: null,
            locationSelection: null,
            entryLocation: null,
            contactName: this.props.profile.name + " " + this.props.profile.surname,
            contactNumber: this.props.profile.cellphoneNumber,
            contactValidation: true,
            hasFutureDate: false,
            hasFutureTime: false,
        };
        this.handleChangeNumbers = this.handleChangeNumbers.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.handleIncidentEventSelection = this.handleIncidentEventSelection.bind(this);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.handleChangeDateValue = this.handleChangeDateValue.bind(this);
        this.setTime = this.setTime.bind(this);
        this.checkStep = this.checkStep.bind(this);
        this.setMouseOut = this.setMouseOut.bind(this);
        this.setMouseIn = this.setMouseIn.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
        this.checkTimeToggle = this.checkTimeToggle.bind(this);
        this.handleIndidentDateClicked = this.handleIndidentDateClicked.bind(this);
        this.listenAwayClick = this.listenAwayClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelfDamage = this.handleSelfDamage.bind(this);
        this.handleHouseholdPerson = this.handleHouseholdPerson.bind(this);
        this.handlePoliceReported = this.handlePoliceReported.bind(this);
        this.handleBlacklisted = this.handleBlacklisted.bind(this);
        this.handleForcedEntry = this.handleForcedEntry.bind(this);
        this.handleVehicleSelection = this.handleVehicleSelection.bind(this);
        this.handleLocationSelection = this.handleLocationSelection.bind(this);
        this.handleForcedEntrySelection = this.handleForcedEntrySelection.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleChangeNumbers(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        value = value.replace(/[^0-9]/gi, "");
        await this.setState({ [name]: value })
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleStepBack() {
        await this.props.dispatchAction(resetCoverItem())
        await this.props.dispatchAction(setDisclaimer(false))
        await this.props.dispatchAction(setStep(1, 1));
    }

    async handleSubmit() {
        if (this.state.stepSubmitted) {
            let dateString = getDateString(this.state.startDate, this.props.claimSubmit.time);
            let futureDateTimeCheck = await this.props.dispatchAction(checkDateTime(dateString));

            if (futureDateTimeCheck) {
                this.setState({
                    hasFutureTime: futureDateTimeCheck.isFutureTime,
                    hasFutureDate: futureDateTimeCheck.isFutureDate
                });
            }
        }
        await this.setState({ stepSubmitted: true })
        await this.checkStep();
        if (!this.state.nextDisabled) {
            var duplicate = await this.props.dispatchAction(checkCellphoneDuplicateClaim(this.props.claimSubmit.incidentEventType.id, this.props.claimSubmit.incidentDate, this.props.claimSubmit.incidentTime, this.props.claimSubmit.incidentType.id, this.props.claimSubmit.selectedRiskItem.id))
            if (!duplicate) {
                if (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_OTHER_ID) {
                    this.props.dispatchAction(submitGeneralClaim());
                    await this.props.dispatchAction(handleNextStep());
                }
                else {
                    await this.props.dispatchAction(handleNextStep());
                }
            }
            else {
                await this.props.dispatchAction(showDuplicateClaim());
            }
        }
    }

    async handleTimeChange(f12: any, f24: any) {
        this.setState({ hasTime: true });
        await this.setState({ time12: f12, time24: f24 });
        let dateString = getDateString(this.state.startDate, this.props.claimSubmit.time);
        let futureDateTimeCheck = await this.props.dispatchAction(checkDateTime(dateString));

        if (futureDateTimeCheck) {
            this.setState({
                hasFutureTime: futureDateTimeCheck.isFutureTime,
                hasFutureDate: futureDateTimeCheck.isFutureDate
            });
        }
    }

    async handleChangeDateValue(date) {
        await this.setState({
            startDate: date
        });
        await this.props.dispatchAction(setDate(date));
        await this.setState({ hasDate: true });
        let dateString = getDateString(this.state.startDate, this.props.claimSubmit.time);
        let futureDateTimeCheck = await this.props.dispatchAction(checkDateTime(dateString));

        if (futureDateTimeCheck) {
            this.setState({
                hasFutureTime: futureDateTimeCheck.isFutureTime,
                hasFutureDate: futureDateTimeCheck.isFutureDate
            });
        }
        if (this.state.stepSubmitted) {
            this.checkStep();
        }
    }

    async setTime(f12: any, f24: any) {
        document.body.removeEventListener("click", this.handleClickAway);
        await this.setState({
            time12: f12,
            time24: f24,
            mouseOut: false,
            isClosed: true,
        });
        await this.props.dispatchAction(setTime(f12, f24))
        await this.props.dispatchAction(setTimeShow());
        await this.setState({ hasTime: false, hasTimeChanged: true });
        let dateString = getDateString(this.state.startDate, this.props.claimSubmit.time);
        let futureDateTimeCheck = await this.props.dispatchAction(checkDateTime(dateString));

        if (futureDateTimeCheck) {
            this.setState({
                hasFutureTime: futureDateTimeCheck.isFutureTime,
                hasFutureDate: futureDateTimeCheck.isFutureDate
            });
        }
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async checkStep() {
        let payload = {}
        await this.setState({ nextDisabled: true })
        if (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_ACCIDENTAL_ID) {
            if (this.state.hasCause && this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                await this.setState({ nextDisabled: false })
                payload = {
                    indidentDate: this.state.startDate,
                    incidentTime: this.props.claimSubmit.time,
                    whatDescription: this.state.incidentDescriptionWhat,
                    incidentEventType: this.state.causeOfCollision,
                }
            }
        }
        else if (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_INTENTIONAL_ID) {
            if (this.state.selfDamage.toLowerCase() === "me") {
                if (this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                    await this.setState({ nextDisabled: false })
                    payload = {
                        indidentDate: this.state.startDate,
                        incidentTime: this.props.claimSubmit.time,
                        whatDescription: this.state.incidentDescriptionWhat,
                        isResponsiblePersonMemberOfHousehold: true,
                        responsiblePersonFullName: this.props.profile.name + " " + this.props.profile.surname,
                        responsiblePersonContactNumber: this.props.profile.cellphoneNumber,
                        incidentEventType: { "id": 250, "description": "Intentional Damage" }
                    }
                }
            }
            else if (this.state.selfDamage.toLowerCase() === "someone") {
                if (this.state.householdPerson === false) {
                    if (this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                        await this.setState({ nextDisabled: false })
                        payload = {
                            indidentDate: this.state.startDate,
                            incidentTime: this.props.claimSubmit.time,
                            whatDescription: this.state.incidentDescriptionWhat,
                            isResponsiblePersonMemberOfHousehold: false,
                            responsiblePersonFullName: this.state.name + " " + this.state.surname,
                            responsiblePersonContactNumber: this.state.contact,
                            incidentEventType: { "id": 251, "description": "Intentional Damage" }
                        }
                    }
                }
                else if (this.state.householdPerson === true) {
                    if (this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && this.state.name && this.state.surname && this.state.contact && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                        await this.setState({ nextDisabled: false })
                        payload = {
                            incidentDate: this.state.startDate,
                            incidentTime: this.props.claimSubmit.time,
                            whatDescription: this.state.incidentDescriptionWhat,
                            isResponsiblePersonMemberOfHousehold: true,
                            responsiblePersonFullName: this.state.name + " " + this.state.surname,
                            responsiblePersonContactNumber: this.state.contact,
                            incidentEventType: { "id": 250, "description": "Intentional Damage" }
                        }
                    }
                }
            }
        }
        else if (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_LOSS_ID) {
            if (this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && this.state.reported && this.state.policeStation && this.state.policeNumber && this.state.isBlacklisted && this.state.blacklistNumber && (this.state.blacklistNumber.length <= 8) && (this.state.blacklistNumber.length >= 6) && (this.state.blacklistNumber.charAt(0) === "2") && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                await this.setState({ nextDisabled: false })
                payload = {
                    indidentDate: this.state.startDate,
                    incidentTime: this.props.claimSubmit.time,
                    whatDescription: this.state.incidentDescriptionWhat,
                    policeReported: this.state.reported,
                    blackListed: this.state.isBlacklisted,
                    blackListNumber: this.state.blacklistNumber,
                    policeReportNumber: this.state.policeNumber,
                    policeReportStation: this.state.policeStation,
                    incidentEventType: { "id": 272, "description": "Item lost" }
                }
            }
        }
        else if (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_THEFT_ID) {
            if (this.state.causeOfCollision.description.toLowerCase() !== "theft from car") {
                if (this.state.hasCause && this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && this.state.reported && this.state.policeStation && this.state.policeNumber && this.state.isBlacklisted && this.state.blacklistNumber && (this.state.blacklistNumber.length <= 8) && (this.state.blacklistNumber.length >= 6) && (this.state.blacklistNumber.charAt(0) === "2") && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                    await this.setState({ nextDisabled: false })
                    payload = {
                        incidentEventType: this.state.causeOfCollision,
                        indidentDate: this.state.startDate,
                        incidentTime: this.props.claimSubmit.time,
                        whatDescription: this.state.incidentDescriptionWhat,
                        policeReported: this.state.reported,
                        blackListed: this.state.isBlacklisted,
                        blackListNumber: this.state.blacklistNumber,
                        policeReportNumber: this.state.policeNumber,
                        policeReportStation: this.state.policeStation,
                    }
                }
            }
            else {
                if (this.state.forcedEntry) {
                    if (this.state.hasCause && this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && this.state.reported && this.state.policeStation && this.state.policeNumber && this.state.isBlacklisted && this.state.blacklistNumber && (this.state.blacklistNumber.length <= 8) && (this.state.blacklistNumber.length >= 6) && (this.state.blacklistNumber.charAt(0) === "2") && this.state.entryLocation && this.state.forcedEntry && this.state.vehicleSelection && this.state.locationSelection && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                        await this.setState({ nextDisabled: false })
                        payload = {
                            incidentEventType: this.state.causeOfCollision,
                            indidentDate: this.state.startDate,
                            incidentTime: this.props.claimSubmit.time,
                            whatDescription: this.state.incidentDescriptionWhat,
                            policeReported: this.state.reported,
                            blackListed: this.state.isBlacklisted,
                            blackListNumber: this.state.blacklistNumber,
                            policeReportNumber: this.state.policeNumber,
                            policeReportStation: this.state.policeStation,
                            selectedTypeOfCarId: this.state.vehicleSelection.id,
                            isVisibleSignsOfEntryIntoCar: this.state.forcedEntry,
                            selectedEntryGainedId: this.state.entryLocation.id,
                            selectedWhereInTheCarId: this.state.locationSelection.id,
                        }
                    }
                }
                else {
                    if (this.state.hasCause && this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && this.state.reported && this.state.policeStation && this.state.policeNumber && this.state.isBlacklisted && this.state.blacklistNumber && (this.state.blacklistNumber.length <= 8) && (this.state.blacklistNumber.length >= 6) && (this.state.blacklistNumber.charAt(0) === "2") && this.state.vehicleSelection && this.state.locationSelection && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                        await this.setState({ nextDisabled: false })
                        payload = {
                            incidentEventType: this.state.causeOfCollision,
                            indidentDate: this.state.startDate,
                            incidentTime: this.props.claimSubmit.time,
                            whatDescription: this.state.incidentDescriptionWhat,
                            policeReported: this.state.reported,
                            blackListed: this.state.isBlacklisted,
                            blackListNumber: this.state.blacklistNumber,
                            policeReportNumber: this.state.policeNumber,
                            policeReportStation: this.state.policeStation,
                            selectedTypeOfCarId: this.state.vehicleSelection.id,
                            isVisibleSignsOfEntryIntoCar: this.state.forcedEntry,
                            selectedEntryGainedId: this.state.entryLocation?.id ?? undefined,
                            selectedWhereInTheCarId: this.state.locationSelection?.id ?? undefined,
                        }
                    }
                }
            }
        }
        else {
            if (this.state.hasDate && this.state.hasTimeChanged && this.state.incidentDescriptionWhat && this.state.contactNumber && this.state.contactName && !this.state.hasFutureTime && !this.state.hasFutureDate) {
                await this.setState({ nextDisabled: false })
                payload = {
                    indidentDate: this.state.startDate,
                    incidentTime: this.props.claimSubmit.time,
                    whatDescription: this.state.incidentDescriptionWhat,
                    incidentEventType: { "id": 999, "description": "Other" },
                    contactPersonFullName: this.state.contactName,
                    contactPersonNumber: this.state.contactNumber,
                }

            }
        }
        if (!this.state.nextDisabled) {
            await this.props.dispatchAction(setFnolReducerPayload(payload));
        }
    }

    async setMouseOut() {
        await this.setState({ mouseOut: true });
        this.listenAwayClick();
    }

    async setMouseIn() {
        await this.setState({ mouseOut: false });
        this.listenAwayClick();
    }

    listenAwayClick() {
        if (this.state.mouseOut && !this.state.isClosed) {
            document.body.addEventListener("click", this.handleClickAway);
        }
        else {
            document.body.removeEventListener("click", this.handleClickAway);
        }
    }

    async handleIndidentDateClicked() {
        this.setState({
            isClosed: false,
        })
        document.body.addEventListener("click", this.handleClickAway);
    }

    async handleClickAway() {
        if (!this.state.isClosed) {
            document.body.removeEventListener("click", this.handleClickAway);
        }

        if (this.state.hasTime) {
            await this.setTime(this.state.time12, this.state.time24);
        }
        else {
            this.props.dispatchAction(setTimeShow());
        }
    }

    async handleIncidentEventSelection(e: any) {
        let coverItem = this.props.claimSubmit.incidentEventList.filter(function (item) {
            return item.id == e
        })
        await this.setState({ causeOfCollision: coverItem[0], hasCause: true });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    checkTimeToggle() {
        if (this.props.claimSubmit.IsIncidentDateClicked) {
            this.props.dispatchAction(setTimeShow());
        }
    }

    handleSelfDamage(selfDamaged) {
        this.setState({ selfDamage: selfDamaged.target.value, householdPerson: undefined });
    }

    async handleHouseholdPerson(selfDamaged) {
        await this.setState({ householdPerson: selfDamaged });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handlePoliceReported(isReported) {
        if (isReported) {
            await this.setState({ reported: isReported, nextDisabled: false });
        }
        else {
            await this.setState({ reported: isReported, nextDisabled: true });
            await this.props.dispatchAction(showPoliceReportInfo());
        }
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleBlacklisted(blacklisted) {
        if (blacklisted) {
            await this.setState({ isBlacklisted: blacklisted, nextDisabled: false });
        }
        else {
            await this.setState({ isBlacklisted: blacklisted, nextDisabled: true });
            await this.props.dispatchAction(showBlacklistInfo());
        }
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleForcedEntry(hadForcedEntry) {
        this.setState({ forcedEntry: hadForcedEntry });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleVehicleSelection(e: any) {
        await this.setState({
            reRender: true
        });
        let dropdownSelected = this.props.claimSubmit.claimVehicleTypes.filter(function (item) {
            return item.id == e
        })
        await this.props.dispatchAction(getAllRiskStolenLocations(dropdownSelected[0].id));
        await this.setState({
            vehicleSelection: dropdownSelected[0], locationSelection: null
        });
        await this.setState({
            reRender: false
        });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleLocationSelection(e: any) {
        let dropdownSelected = this.props.claimSubmit.stolenLocations.filter(function (item) {
            return item.id == e
        })
        this.setState({
            locationSelection: dropdownSelected[0]
        });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    async handleForcedEntrySelection(e: any) {
        let dropdownSelected = this.props.claimSubmit.forcedEntryType.filter(function (item) {
            return item.id == e
        })
        this.setState({
            entryLocation: dropdownSelected[0]
        });
        if (this.state.stepSubmitted) {
            await this.checkStep();
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.dispatchAction(getVehicleTypes());
        this.props.dispatchAction(getVehicleForcedEntryTypes());
    }

    public render() {
        let incidentEventTypes = <div></div>;
        if (this.props.claimSubmit.incidentEventList) {
            incidentEventTypes = this.props.claimSubmit.incidentEventList.map((event) => {
                return <>
                    <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                        {event.description}
                    </Dropdown.Item>
                    <div className="ssp-hr-container">
                        <hr className="cover-divider" />
                    </div>
                </>
            });
        }

        let vehicleType = <div></div>;
        if (this.props.claimSubmit.claimVehicleTypes) {
            vehicleType = this.props.claimSubmit.claimVehicleTypes.map((event) => {
                return <>
                    <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                        {event.description}
                    </Dropdown.Item>
                    <div className="ssp-hr-container">
                        <hr className="cover-divider" />
                    </div>
                </>
            });
        }

        let stolenLocations = <div></div>;
        if (this.props.claimSubmit.stolenLocations) {
            stolenLocations = this.props.claimSubmit.stolenLocations.map((event) => {
                return <>
                    <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                        {event.description}
                    </Dropdown.Item>
                    <div className="ssp-hr-container">
                        <hr className="cover-divider" />
                    </div>
                </>
            });
        }

        let forcedEntryType = <div></div>;
        if (this.props.claimSubmit.forcedEntryType) {
            forcedEntryType = this.props.claimSubmit.forcedEntryType.map((event) => {
                return <>
                    <Dropdown.Item eventKey={event.id} key={event.id} value={event.id}>
                        {event.description}
                    </Dropdown.Item>
                    <div className="ssp-hr-container">
                        <hr className="cover-divider" />
                    </div>
                </>
            });
        }

        let claimDateInfo =
            <>
                <div className="col-12 nopa ssp-form mt-20px">
                    <div className={'form-group position-relative ' + (this.state.stepSubmitted && (!this.state.hasDate || this.state.hasFutureDate) & this.state.nextDisabled ? 'has-error' : '')} onClick={this.checkTimeToggle}>
                        <label className={'form-label ssp-calendar-label mb-6px' + (this.state.startDate !== "" ? "" : " no-opacity")}>Incident date</label>
                        <ModernDatepicker
                            date={this.state.startDate}
                            format={'DD-MM-YYYY'}
                            showBorder
                            onChange={(date) => this.handleChangeDateValue(date)}
                            placeholder="Select incident date"
                            maxDate={this.state.maxDate}
                            id="FNOL-datepicker"
                            className="ssp-calendar-input calendar-inline-icon"
                        />
                        {this.state.stepSubmitted && !this.state.hasDate && this.state.nextDisabled &&
                            <div className="form-inline-error">Date is required</div>
                        }
                        {this.state.stepSubmitted && this.state.hasFutureDate && this.state.nextDisabled &&
                            <div className="form-inline-error">The date should not be in the future</div>
                        }
                    </div>
                    {this.props.claimSubmit.timeDisplay &&
                        <div className={'form-group position-relative mb-20px ' + (this.state.hasFutureTime ? ' has-error' : '')} >
                            {this.props.claimSubmit.timeDisplay && (!this.state.hasFutureTime) &&
                                <label className={'form-label' + (this.props.claimSubmit.timeDisplay ? "" : " no-opacity")}>Incident time</label>
                            }
                            {this.props.claimSubmit.timeDisplay && (this.state.hasFutureTime) &&
                                <label className={'form-label' + (this.props.claimSubmit.timeDisplay ? " text-red" : " no-opacity")}>Incident time</label>
                            }
                            <input type="button" className={this.state.hasFutureTime && this.state.stepSubmitted && this.state.hasTimeChanged && this.state.nextDisabled ? "datetime-form-red form-control ssp-time-input text-left watch-inline-icon" : "form-control ssp-time-input text-left watch-inline-icon"} value={this.props.claimSubmit.timeDisplay ? this.props.claimSubmit.timeDisplay : 'Select incident time'} disabled={this.props.isClosed} onClick={this.handleIndidentDateClicked} />
                            <div className={this.props.claimSubmit.IsIncidentDateClicked ? 'visible w-100' : 'invisible'} onMouseLeave={this.setMouseOut} onMouseEnter={this.setMouseIn}>
                                <TimeKeeper
                                    time={this.props.claimSubmit.timeDisplay}
                                    onChange={(newTime) => this.handleTimeChange(newTime.formatted12, newTime.formatted24)}
                                    doneButton={(newTime) => (
                                        <div
                                            className="btn btn-solid-red process"
                                            onClick={() => this.setTime(newTime.formatted12, newTime.formatted24)}
                                        >
                                            Close
                                        </div>
                                    )}
                                    switchToMinuteOnHourSelect
                                    closeOnMinuteSelect
                                />
                            </div>
                            {this.state.stepSubmitted && !this.state.hasTimeChanged && this.state.nextDisabled &&
                                <div className="form-inline-error">Time is required</div>
                            }
                            {this.state.hasFutureTime && this.state.stepSubmitted && this.state.hasTimeChanged && this.state.nextDisabled &&
                                <div className="form-inline-error">The time should not be in the future</div>
                            }
                        </div>
                    }
                    <div className={'form-group cellphone-incidentTextarea mt-20px ' + (this.state.stepSubmitted && !this.state.incidentDescriptionWhat ? ' has-error' : '')}>
                        <p className={"fnol-what-happened-intro-p font-weight-bold line-height-normal mb-8px" + (this.state.stepSubmitted && !this.state.incidentDescriptionWhat ? ' text-red' : '')}>Tell us what happened</p>
                        <textarea id="incidentDescriptionWhat" name="incidentDescriptionWhat" rows={4} cols={50} className={(this.state.stepSubmitted && !this.state.incidentDescriptionWhat ? 'ssp-form-textarea-error' : 'ssp-form-textarea')} placeholder="Describe the incident" value={this.state.incidentDescriptionWhat} onChange={this.handleChange} />
                        {this.state.stepSubmitted && !this.state.incidentDescriptionWhat && this.state.nextDisabled &&
                            <div className="form-inline-error">Description of what happened is required</div>
                        }
                    </div>
                </div>
            </>


        let policeReport =
            <>
                <div className="row noma cellphoneclaims-parent-row">
                    <div className="col nopa">
                        <p className="font-size-16px glassclaims-intro-p mt-10px"><b>Was the incident reported to the police</b></p>
                    </div>
                    <div className="nopa text-lg-right cellphoneclaims-button-col">
                        <div className="row noma cellphoneclaims-button-row">
                            <div className="col nopa cellphoneclaims-button-no">
                                <button className={!this.state.reported && this.state.reported !== undefined ? "btn btn-outline-dark nopa active question-button" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handlePoliceReported(false)}>No</button>
                            </div>
                            <div className="glassclaims-mobile-gutter nopa"></div>
                            <div className="col nopa cellphoneclaims-button-yes">
                                <button className={this.state.reported && this.state.reported !== undefined ? "btn btn-outline-dark nopa active question-button" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handlePoliceReported(true)}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {!this.state.reported && this.state.reported !== undefined &&
                    <>
                        <hr className="border-red" />
                        <p className='text-red mb-0px'>Please report the incident before continuing with the claim notification</p>
                    </>
                }
                {this.state.reported && this.state.reported !== undefined &&
                    <>
                        <hr className="claims-v2-hr-2px mb-0px" />
                        <div className={"col-12 col-lg nopa" + (this.state.policeStation !== "" ? " mt-20px" : "")}>
                            <div className={'form-group noma' + (this.state.stepSubmitted && !this.state.policeStation ? 'has-error' : '')}>
                                <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.policeStation !== "" ? "" : " no-opacity")}>Which police station did you report the incident at</label>
                                <input id="cellphoneClaimPoliceStation" type="text" placeholder="Which police station did you report the incident at." className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.policeStation ? 'form-control-error' : "underline")} name="policeStation" value={this.state.policeStation} onChange={this.handleChange} />
                                {this.state.stepSubmitted && !this.state.policeStation && this.state.nextDisabled &&
                                    <div className="form-inline-error">Police station required</div>
                                }
                            </div>
                        </div>
                        <div className={"col-12 col-lg nopa" + (this.state.policeNumber !== "" ? " mt-20px" : " ")}>
                            <div className={'form-group noma' + (this.state.stepSubmitted && !this.state.policeNumber ? 'has-error' : '')}>
                                <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.policeNumber !== "" ? "" : " no-opacity")}>SAPS case no.</label>
                                <input id="cellphoneClaimPoliceNumber" type="text" placeholder="SAPS case no." className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.policeNumber ? 'form-control-error' : "underline")} name="policeNumber" value={this.state.policeNumber} onChange={this.handleChange} />
                                {this.state.stepSubmitted && !this.state.policeNumber && this.state.nextDisabled &&
                                    <div className="form-inline-error">Police number is required</div>
                                }
                            </div>
                        </div>
                        <div className="row noma glassclaims-parent-row mt-17px">
                            <div className="col nopa">
                                <p className="glassclaims-intro-p font-size-16px font-weight-bold line-height-normal">Was the phone blacklisted? <img className="raftooltip ml-10px" id="rafTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="blacklistTooltip" data-tip="" />
                                    <ReactTooltip id="blacklistTooltip" className="rafreacttool" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000} >If your phone's 'blacklisted' it means that it's been registered as lost or stolen and that some of its features may be blocked.</ReactTooltip>
                                </p>
                            </div>
                            <div className="nopa text-lg-right cellphoneclaims-button-col">
                                <div className="row noma cellphoneclaims-button-row">
                                    <div className="col nopa cellphoneclaims-button-no">
                                        <button className={!this.state.isBlacklisted && this.state.isBlacklisted !== undefined ? "btn btn-outline-dark nopa question-button active" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handleBlacklisted(false)}>No</button>
                                    </div>
                                    <div className="cellphoneclaims-mobile-gutter nopa"></div>
                                    <div className="col nopa cellphoneclaims-button-yes">
                                        <button className={this.state.isBlacklisted && this.state.isBlacklisted !== undefined ? "btn btn-outline-dark nopa question-button active" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handleBlacklisted(true)}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!this.state.isBlacklisted && this.state.isBlacklisted !== undefined &&
                            <>
                                <hr className="border-red" />
                                <p className='text-red'>Please blacklist your phone before continuing with the claim notification</p>
                            </>
                        }
                        {this.state.isBlacklisted && this.state.isBlacklisted !== undefined &&
                            <>
                                <hr className="claims-v2-hr-2px mb-0px" />
                                <div className={"col-12 col-lg nopa " + (this.state.blacklistNumber !== "" ? " mt-22px" : "")}>
                                    <div className={'form-group noma' + (this.state.stepSubmitted && !this.state.blacklistNumber ? 'has-error' : '')}>
                                        <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.blacklistNumber !== "" ? "" : " no-opacity")}>What is your blacklist reference no. (6-8 digit no.)</label>
                                        <input id="cellphoneClaimBlacklistNumber" type="text" maxLength={8} placeholder="What is your blacklist reference no. (6-8 digit no.)" className={"form-control clientName noma nopa " + (this.state.stepSubmitted && (this.state.blacklistNumber.length <= 8) && (this.state.blacklistNumber.length >= 6) && (this.state.blacklistNumber) && (this.state.blacklistNumber.charAt(0) !== 2) && this.state.nextDisabled ? 'form-control-error text-red textbox-border-red' : "underline")} name="blacklistNumber" value={this.state.blacklistNumber} onChange={this.handleChangeNumbers} />
                                        {this.state.stepSubmitted && (this.state.blacklistNumber.length <= 8) && (this.state.blacklistNumber.length >= 6) && (this.state.blacklistNumber) && (this.state.blacklistNumber.charAt(0) !== 2) && this.state.nextDisabled &&
                                            <div className="form-inline-error"> The number entered is not valid. Please obtain the correct blacklisting number</div>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                    </>
                }
            </>

        let claimCauseDropdown = <div></div>
        if ((this.props.claimSubmit.incidentEventList && this.props.claimSubmit.incidentEventList.length > 0)) {
            claimCauseDropdown =
                <>
                    <div className="mb-0px mt-20px" />
                    <div className={'form-group chooseIncident ' + (this.state.stepSubmitted && this.state.causeOfCollision.length < 1 ? ' has-error' : '')}>
                        <Dropdown id="CollisionCause-fnol" className="ssp-dropdown ssp-dropdown-item-list-no-images"
                            onSelect={this.handleIncidentEventSelection}
                            onToggle={this.handleCoverDropdownToggle}>
                            <Dropdown.Toggle id="dropdown-basic" className={(this.state.stepSubmitted && this.state.causeOfCollision.length < 1 ? 'ssp-dropdown-select-button-error' : 'ssp-dropdown-select-button')}>
                                {!(this.state.causeOfCollision.length < 1) &&
                                    <>
                                        <div className="row ssp-dropdown-select-row">
                                            <div className="col">
                                                {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_THEFT_ID &&
                                                    <span className="ssp-dropdown-select-choose-text-selected-product">Choose an incident</span>
                                                }
                                                {this.props.claimSubmit.incidentType.id !== CELLPHONE_CLAIM_THEFT_ID &&
                                                    <span className="ssp-dropdown-select-choose-text-selected-product">Cause of damage</span>
                                                }
                                                <span className="ssp-dropdown-select-selected-product" id="selectedCollisionCellphone">{this.state.causeOfCollision.description}</span>
                                            </div>
                                            <div className="ssp-dropdown-icon"></div>
                                        </div>
                                    </>
                                }
                                {this.state.causeOfCollision.length < 1 &&
                                    <div className="row ssp-dropdown-select-row">
                                        {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_THEFT_ID &&
                                            <div className={"col ssp-dropdown-select-choose-text-no-product" + (this.state.stepSubmitted && this.state.causeOfCollision.length < 1 ? ' text-red' : '')}>
                                                Choose an incident
                                            </div>
                                        }
                                        {this.props.claimSubmit.incidentType.id !== CELLPHONE_CLAIM_THEFT_ID &&
                                            <div className={"col ssp-dropdown-select-choose-text-no-product" + (this.state.stepSubmitted && this.state.causeOfCollision.length < 1 ? ' text-red' : '')}>
                                                Cause of damage
                                            </div>
                                        }
                                        <div className="ssp-dropdown-icon"></div>
                                    </div>
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                {incidentEventTypes}
                            </Dropdown.Menu>
                        </Dropdown>
                        {this.state.stepSubmitted && this.state.causeOfCollision.length < 1 && this.state.nextDisabled &&
                            <div className="form-inline-error">Event type is required</div>
                        }
                    </div>
                </>
        }

        return (
            <div className="col ssp-container-fnol-repairs ssp-container-fnol-step-header-padding">
                <div className="noma">
                    <div className="col-12 nopa ssp-header-fnol-ssp-header-fnol-what-happened">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>Claim details</h3>
                            </div>
                        </div>
                    </div>
                    <hr className="hr-minus21px" />
                    <div>
                        <p className="font-weight-normal mb-20px line-height-normal">Before we can look into your claim, we need a few details</p>
                        {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_ACCIDENTAL_ID &&
                            <>
                                {claimCauseDropdown}
                                {claimDateInfo}
                            </>
                        }
                        {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_INTENTIONAL_ID &&
                            <>
                                <p className="mb-0px font-weight-normal line-height-normal">'Intentional damage' is when your phone was damaged knowingly, or on purpose</p>
                                <hr className="cellphoneclaims-hr-2px mt-20px mb-20px" />
                                <div className="row noma">
                                    <div className="col nopa">
                                        <p className="font-size-16px font-weight-bold mb-0px">Was the damage caused by you or someone else?</p>
                                    </div>
                                    <div className="col-12 nopa mt-15px">
                                        <div className="form-check nopa mb-14px">
                                            <input className="form-check-input radio-custom glassclaims-radio-custom" type="radio" name="radio-group" id="damageMe" value="me" onChange={this.handleSelfDamage} />
                                            <label className="form-check-label radio-custom-label glassclaims-radio-custom-label" htmlFor="damageMe">
                                                Me
                                            </label>
                                        </div>
                                        <div className="form-check nopa">
                                            <input className="form-check-input radio-custom glassclaims-radio-custom" type="radio" name="radio-group" id="damageSomeoneElse" value="someone" onChange={this.handleSelfDamage} />
                                            <label className="form-check-label radio-custom-label glassclaims-radio-custom-label" htmlFor="damageSomeoneElse">
                                                Someone else
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {this.state.selfDamage &&
                                    <>
                                        {this.state.selfDamage === "someone" &&
                                            <>
                                                <hr className="cellphoneclaims-hr-2px mt-20px mb-20px" />
                                                <div className="row noma nopa glassclaims-parent-row">
                                                    <div className="col nopa">
                                                        <p className="font-size-16px glassclaims-intro-p"><b>Is this person a member of your household</b></p>
                                                    </div>
                                                    <div className="nopa text-lg-right cellphoneclaims-button-col">
                                                        <div className="row noma cellphoneclaims-button-row">
                                                            <div className="col nopa cellphoneclaims-button-no">
                                                                <button className={!this.state.householdPerson && this.state.householdPerson !== undefined ? "btn btn-outline-dark nopa active question-button" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handleHouseholdPerson(false)}>No</button>
                                                            </div>
                                                            <div className="cellphoneclaims-mobile-gutter nopa"></div>
                                                            <div className="col nopa glassclaims-button-yes">
                                                                <button className={this.state.householdPerson && this.state.householdPerson !== undefined ? "btn btn-outline-dark nopa active question-button" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handleHouseholdPerson(true)}>Yes</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.householdPerson !== undefined &&
                                                    <>
                                                        <hr className="cellphoneclaims-hr-2px mt-20px mb-20px" />
                                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Please fill in their details</p>
                                                        <p className="font-weight-normal line-height-normal mb-0px">Providing this person’s details speeds up the claim progress so please be as accurate as possible</p>
                                                        <div className={"col-12 col-lg nopa" + (this.state.name !== "" ? " mt-20px" : " mt-15px")}>
                                                            <div className={'form-group noma ' + (this.state.stepSubmitted && !this.state.name ? 'has-error' : '')}>
                                                                <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.name !== "" ? "" : " d-none no-opacity")}>Name</label>
                                                                <input id="phoneClaimName" type="text" placeholder="Type name" className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.name ? 'form-control-error' : "underline")} name="name" value={this.state.name} onChange={this.handleChange} />
                                                                {this.state.stepSubmitted && !this.state.name && this.state.nextDisabled && this.state.householdPerson && this.state.householdPerson !== undefined &&
                                                                    <div className="form-inline-error">Name required</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className={"col-12 col-lg nopa" + (this.state.surname !== "" ? " mt-20px" : "")}>
                                                            <div className={'form-group noma ' + (this.state.stepSubmitted && !this.state.surname ? 'has-error' : '')}>
                                                                <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.surname !== "" ? "" : " no-opacity")}>Surname</label>
                                                                <input id="phoneClaimSurname" type="text" placeholder="Type surname" className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.surname ? 'form-control-error' : "underline")} name="surname" value={this.state.surname} onChange={this.handleChange} />
                                                                {this.state.stepSubmitted && !this.state.surname && this.state.nextDisabled && this.state.householdPerson && this.state.householdPerson !== undefined &&
                                                                    <div className="form-inline-error">Surname is required</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className={"col-12 col-lg nopa" + (this.state.contact !== "" ? " mt-20px" : "")}>
                                                            <div className={'form-group noma ' + (this.state.stepSubmitted && !this.state.contact ? 'has-error' : '')}>
                                                                <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.contact !== "" ? "" : " no-opacity")}>Phone no.</label>
                                                                <input id="phoneClaimContact" type="text" placeholder="Type phone number" className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.contact ? 'form-control-error' : "underline")} name="contact" value={this.state.contact} onChange={this.handleChange} />
                                                                {this.state.stepSubmitted && !this.state.contact && this.state.nextDisabled && this.state.householdPerson && this.state.householdPerson !== undefined &&
                                                                    <div className="form-inline-error">Contact details are required</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-12 nopa mt-30px mb-20px">
                                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0px">Incident details</p>
                                                        </div>
                                                        {claimDateInfo}
                                                    </>
                                                }
                                            </>
                                        }
                                        {this.state.selfDamage === "me" &&
                                            <>
                                                <hr className="cellphoneclaims-hr-2px mt-20px mb-20px" />
                                                {claimDateInfo}
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                        {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_LOSS_ID &&
                            <>
                                {claimDateInfo}
                                <hr className="cellphoneclaims-hr-2px mb-20px" />
                                {policeReport}
                            </>
                        }
                        {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_THEFT_ID &&
                            <>
                                {claimCauseDropdown}
                                {(this.state.causeOfCollision.id === 306) &&
                                    <>
                                        <div className="mb-0px mt-20px" />
                                        <div className={'form-group ' + (this.state.stepSubmitted && !this.state.vehicleSelection ? ' has-error' : '')}>
                                            <Dropdown id="CollisionCause-fnol" className="ssp-dropdown ssp-dropdown-item-list-no-images"
                                                onSelect={this.handleVehicleSelection}
                                                onToggle={this.handleCoverDropdownToggle}>
                                                <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button">
                                                    {this.state.vehicleSelection &&
                                                        <>
                                                            <div className="row ssp-dropdown-select-row">
                                                                <div className="col">
                                                                    <span className="ssp-dropdown-select-choose-text-selected-product">What type of car was it?</span>
                                                                    <span className="ssp-dropdown-select-selected-product" id="selectedVehicleCellphone">{this.state.vehicleSelection.description}</span>
                                                                </div>
                                                                <div className="ssp-dropdown-icon"></div>
                                                            </div>
                                                        </>
                                                    }
                                                    {!this.state.vehicleSelection &&
                                                        <div className="row ssp-dropdown-select-row">
                                                            <div className="col ssp-dropdown-select-choose-text-no-product">
                                                                What type of car was it?
                                                            </div>
                                                            <div className="ssp-dropdown-icon"></div>
                                                        </div>
                                                    }
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                    {vehicleType}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {this.state.stepSubmitted && !this.state.vehicleSelection && this.state.nextDisabled &&
                                                <div className="form-inline-error">Vehicle type is required</div>
                                            }
                                        </div>
                                        {this.state.vehicleSelection && !this.state.reRender &&
                                            <>
                                                <div className="mb-0px mt-20px" />
                                                <div className={'form-group ' + (this.state.stepSubmitted && !this.state.locationSelection ? ' has-error' : '')}>
                                                    <Dropdown id="WhereWasPhone-fnol" className="ssp-dropdown ssp-dropdown-item-list-no-images cellphoneClaimsDetails"
                                                        onSelect={this.handleLocationSelection}
                                                        onToggle={this.handleCoverDropdownToggle}>
                                                        <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button">
                                                            {this.state.locationSelection &&
                                                                <>
                                                                    <div className="row ssp-dropdown-select-row">
                                                                        <div className="col">
                                                                            <span className="ssp-dropdown-select-choose-text-selected-product">Where was the phone when it was stolen</span>
                                                                            <span className="ssp-dropdown-select-selected-product" id="selectedLocationCellphone">{this.state.locationSelection.description}</span>
                                                                        </div>
                                                                        <div className="ssp-dropdown-icon"></div>
                                                                    </div>
                                                                </>
                                                            }
                                                            {!this.state.locationSelection &&
                                                                <div className="row ssp-dropdown-select-row">
                                                                    <div className="col ssp-dropdown-select-choose-text-no-product">
                                                                        Where was the phone when it was stolen
                                                                    </div>
                                                                    <div className="ssp-dropdown-icon"></div>
                                                                </div>
                                                            }
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                            {stolenLocations}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    {this.state.stepSubmitted && !this.state.locationSelection && this.state.nextDisabled &&
                                                        <div className="form-inline-error">Location is required</div>
                                                    }
                                                </div>
                                            </>
                                        }
                                        <div className="row noma nopa  cellphoneclaims-parent-row mt-20px">
                                            <div className="col nopa">
                                                <p className="font-size-16px glassclaims-intro-p mt-10px"><b>Were there visible signs of forced entry</b></p>
                                            </div>
                                            <div className="nopa text-lg-right cellphoneclaims-button-col">
                                                <div className="row noma cellphoneclaims-button-row">
                                                    <div className="col nopa cellphoneclaims-button-no">
                                                        <button className={!this.state.forcedEntry && this.state.forcedEntry !== undefined ? "btn btn-outline-dark nopa active question-button" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handleForcedEntry(false)}>No</button>
                                                    </div>
                                                    <div className="glassclaims-mobile-gutter nopa"></div>
                                                    <div className="col nopa cellphoneclaims-button-yes">
                                                        <button className={this.state.forcedEntry && this.state.forcedEntry !== undefined ? "btn btn-outline-dark nopa active question-button" : "btn btn-outline-dark nopa question-button"} onClick={() => this.handleForcedEntry(true)}>Yes</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="cellphoneclaims-hr-2px mb-20px" />
                                        {this.state.forcedEntry !== undefined && this.state.forcedEntry &&
                                            <div className={'form-group ' + (this.state.stepSubmitted && !this.state.entryLocation ? ' has-error' : '')}>
                                                <Dropdown id="HowEntryGained-fnol" className="ssp-dropdown ssp-dropdown-item-list-no-images"
                                                    onSelect={this.handleForcedEntrySelection}
                                                    onToggle={this.handleCoverDropdownToggle}>
                                                    <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button">
                                                        {this.state.entryLocation &&
                                                            <>
                                                                <div className="row ssp-dropdown-select-row">
                                                                    <div className="col">
                                                                        <span className="ssp-dropdown-select-choose-text-selected-product">How was entry gained?</span>
                                                                        <span className="ssp-dropdown-select-selected-product" id="selectedEntryCellphone">{this.state.entryLocation.description}</span>
                                                                    </div>
                                                                    <div className="ssp-dropdown-icon"></div>
                                                                </div>
                                                            </>
                                                        }
                                                        {!this.state.entryLocation &&
                                                            <div className="row ssp-dropdown-select-row">
                                                                <div className="col ssp-dropdown-select-choose-text-no-product">
                                                                    How was entry gained?
                                                                </div>
                                                                <div className="ssp-dropdown-icon"></div>
                                                            </div>
                                                        }
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu title="Select type of incident" id="nav-dropdown-type">
                                                        {forcedEntryType}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                {this.state.stepSubmitted && !this.state.entryLocation && this.state.nextDisabled &&
                                                    <div className="form-inline-error">Entry type is required</div>
                                                }
                                            </div>
                                        }
                                    </>
                                }
                                {claimDateInfo}
                                <hr className="claims-v2-hr-2px" />
                                {policeReport}
                            </>
                        }
                        {this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_OTHER_ID &&
                            <>
                                {claimDateInfo}
                                <div className="fnol-form-group fnol-form-sub-header">
                                    <h4>Who should our supplier contact regarding repairs/replacement</h4>
                                </div>
                                <div className="col-12 col-lg nopa">
                                    <div className={'form-group noma ' + (this.state.stepSubmitted && !this.state.contactName ? 'has-error' : '')}>
                                        <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.contactName !== "" ? "" : " no-opacity")}>Name</label>
                                        <input id="phoneClaimContact" type="text" placeholder="Phone number" className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.contactName ? 'form-control-error' : "underline")} name="contactName" value={this.state.contactName} onChange={this.handleChange} />
                                        {this.state.stepSubmitted && !this.state.contactName && this.state.nextDisabled &&
                                            <div className="form-inline-error">Name is require</div>
                                        }
                                    </div>
                                </div>
                                <div className="col-12 col-lg nopa mt-10px">
                                    <div className={'form-group noma ' + (this.state.stepSubmitted && !this.state.contactNumber ? 'has-error' : '')}>
                                        <label className={'form-label font-size-14px font-weight-normal line-height-normal mb-6px ' + (this.state.contactNumber !== "" ? "" : " no-opacity")}>Phone no.</label>
                                        <input id="phoneClaimContact" type="text" placeholder="Phone number" maxLength={10} className={"form-control clientName noma nopa " + (this.state.submitted && !this.state.contactNumber ? 'form-control-error' : "underline")} name="contact" value={this.state.contactNumber} onChange={this.handleChange} />
                                        {this.state.stepSubmitted && !this.state.contactNumber && this.state.nextDisabled &&
                                            <div className="form-inline-error">Contact details are required</div>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        {(!this.state.reported && this.state.reported !== undefined) || (this.state.isBlacklisted !== undefined) || (this.props.claimSubmit.incidentType.id === CELLPHONE_CLAIM_OTHER_ID) ? "" : <hr className='cellphoneclaims-hr-2px mb-0px mt-20px' />}
                        <div className="nopa fnol-steps-buttonholder mt-40px">
                            <button className="btn btn-solid-red fnol-buttonreverse-button-next glassclaims-button-next" onClick={this.handleSubmit} disabled={this.state.nextDisabled} id="submit" >Next</button>
                            <button className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleStepBack} id="back">Back</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellphoneClaimsDetails)
